import React from "react";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/DeleteOutline";
import { makeStyles } from "@material-ui/core/styles";

// Editor dos destinos de transferência do agente: uma lista pré-aprovada de
// {rótulo, número/ramal}. Em ligação, a IA ganha a função transferir_humano e
// escolhe UM destino pelo rótulo; o backend disca o número (externo) ou ramal
// (SIP interno da conta). Lista vazia = o agente não pode transferir.
const useStyles = makeStyles(theme => ({
  hint: { fontSize: 12.5, color: theme.app.textSecondary, marginBottom: 10 },
  row: { display: "flex", gap: 8, alignItems: "center", marginBottom: 10 },
  label: { width: 180, flexShrink: 0 },
  number: { flex: 1 },
  empty: { fontSize: 12.5, color: theme.app.textTertiary, padding: "6px 0 12px" },
}));

const AgentTransferEditor = ({ value, onChange }) => {
  const classes = useStyles();
  const dests = Array.isArray(value) ? value : [];

  const patch = (i, key, v) => onChange(dests.map((d, idx) => (idx === i ? { ...d, [key]: v } : d)));
  const add = () => onChange([...dests, { label: "", number: "" }]);
  const remove = i => onChange(dests.filter((_, idx) => idx !== i));

  return (
    <div>
      <Typography className={classes.hint}>
        Destinos que a IA pode transferir. Ela escolhe um pelo <b>rótulo</b> quando não resolver ou a pessoa pedir um
        humano. O número pode ser externo (ex.: <span>+11988887777</span>) ou um <b>ramal</b> da sua conta (ex.: 1001).
      </Typography>

      {dests.length === 0 && (
        <Typography className={classes.empty}>Nenhum destino. O agente não terá a ação de transferir a ligação.</Typography>
      )}

      {dests.map((d, i) => (
        <div key={i} className={classes.row}>
          <TextField
            className={classes.label}
            label="Rótulo"
            placeholder="Vendas"
            value={d.label || ""}
            onChange={e => patch(i, "label", e.target.value)}
            size="small"
            variant="outlined"
          />
          <TextField
            className={classes.number}
            label="Número ou ramal"
            placeholder="+11988887777 ou 1001"
            value={d.number || ""}
            onChange={e => patch(i, "number", e.target.value)}
            size="small"
            variant="outlined"
          />
          <IconButton size="small" onClick={() => remove(i)} title="Remover">
            <DeleteIcon fontSize="small" />
          </IconButton>
        </div>
      ))}

      <Button size="small" variant="outlined" color="secondary" startIcon={<AddIcon />} onClick={add}>
        Adicionar destino
      </Button>
    </div>
  );
};

export default AgentTransferEditor;
